import { render } from "./NewsComponent.vue?vue&type=template&id=f51b0786"
import script from "./NewsComponent.vue?vue&type=script&lang=js"
export * from "./NewsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__